import { Tooltip } from '@mui/material';
import styled from 'styled-components';
import Button from '../../Button';
import { Flex } from '../../Flex';
import {
  ToolRendererArgs,
  OnUserInteraction,
  ToolRendererUserSelectedValue,
} from '../types';

const ActionButton = styled(Button)<{ $isActive: boolean }>`
  border-color: ${({ theme, $isActive }) =>
    $isActive ? theme.palette.common.black : undefined} !important;
`;

const TruncatedText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

const userActionsToolRenderer = (
  toolArgs: ToolRendererArgs,
  onUserInteraction?: OnUserInteraction,
  selectedValue?: ToolRendererUserSelectedValue,
) => {
  const actions = toolArgs?.actions || [];

  return (
    <Flex sx={{ gap: 1, flexWrap: 'wrap' }}>
      {actions.map((action: string) => (
        <Tooltip title={action} key={action}>
          <ActionButton
            $isActive={selectedValue?.selectedAction === action}
            variant="outlined"
            disabled={!!selectedValue}
            onClick={() => onUserInteraction?.({ selectedAction: action })}
          >
            <TruncatedText>{action}</TruncatedText>
          </ActionButton>
        </Tooltip>
      ))}
    </Flex>
  );
};

export default userActionsToolRenderer;
